<template>
  <AbaDownload :titulo="titulo" v-if="!loading">
    <div slot="subtitulo" class="segunda-cor-fonte">
      Relatório de Prestadores Unimed não operadora.
    </div>
    <div style="width: 360px" v-if="!ocorreuErro">
      <CardDownload
        :nomeArquivo="objetoArquivo.nomeArquivo"
        style="margin-bottom: 72px"
      />

      <unicom-botao @click="baixar" nomeIcone="download-cloud" :largura="360">
        BAIXAR
      </unicom-botao>
    </div>
    <div class="titulo negrito my-auto" v-else>NENHUM ARQUIVO ENCONTRADO</div>
  </AbaDownload>
  <unicom-spinner
    v-else
    style="
      min-height: 450px;
      display: flex;
      flex-flow: wrap column;
      justify-content: center;
    "
    :tamanhoLoading="62"
    :tamanhoLinha="7"
    :velocidade="0.5"
    :marginTopTexto="30"
    mensagem="Carregando..."
  />
</template>

<script>
import AbasMixin from "../AbasMixin";
import AbaDownloadMixin from "../AbaDownloadMixin";

export default {
  mixins: [AbasMixin, AbaDownloadMixin],
  data() {
    let objetoArquivo = {
      nomeArquivo: ""
    };

    return {
      loading: false,
      objetoArquivo,
      ocorreuErro: false
    };
  },
  beforeMount() {
    this.init();
  },
  methods: {
    init() {
      this.inicializarArquivo();
    },
    inicializarArquivo() {
      this.loading = true;
      this.sleep(250).finally(() => {
        this.getArquivoPrestadoresNaoOperadora()
          .then(res => {
            const { nomeArquivo } = res.data;

            this.objetoArquivo = { nomeArquivo };
          })
          .catch(() => {
            this.ocorreuErro = true;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    baixar() {
      this.$store.commit("setLoadingModal", true);

      this.getDownloadPrestadoresNaoOperadora()
        .then(res => {
          if (res.status === 204) return;
          this.$helpers.baixarArquivo(
            res.data,
            res.headers["content-disposition"]
          );
        })
        .finally(() => {
          this.$store.commit("setLoadingModal", false);
        });
    }
  }
  // computed: {
  // computedFilter() {
  //   const { competencia } = this.objetoFiltro;

  //   if (competencia.length > 0) return { competencia };

  //   return {};
  // }
  // }
};
</script>

<style></style>
